import React, { useState } from 'react';
import './reactFlow.css'
import { getTaskDetails } from "src/pages/reactflow/dynamoDB";
import {useLocation} from "react-router-dom";
import queryString from "query-string";


export default () => {
    const [ddbItems, setDdbItems] = useState([]);
    const[domainName, setWorkflowName] = useState("SNOW");
    const Location = useLocation();
    const urlParams = queryString.parse(Location.search);
    const workflowName = urlParams["workflow_name"]


    if(ddbItems.length === 0) {
        getTaskDetails(`_SupportedTasksDetails`,  'ToolName', `ADAPT`).then( (items) => {
            console.log(items)
            setDdbItems(items)
            // setWorkflowName(items[0].ToolName)
        })
    }
    const onDragStart = (event, node) => {
        const stringNode = JSON.stringify(node)
        event.dataTransfer.setData('application/reactflow', stringNode)
        event.dataTransfer.effectAllowed = 'move'
    }

    return (
        <div className="aside">

            <aside>
                <div className="description" > <h4> You can drag these tasks to the pane on the right for creating a Workflow for {workflowName} </h4></div>
                <div className="default">
                    <h5 className="header">{ domainName }</h5>
                </div>

                {
                    ddbItems.map((node) => {
                        return<div key={node.TaskName} className="defaultNode input"  onDragStart={(event) => onDragStart(event, { type: 'taskNode', name: node.TaskName,
                            inputFields: node.input, output: node.output, endpoint: node.endpoint, toolName: workflowName, displayName: node.TaskName})} draggable>
                            {node.TaskName}
                        </div>

                    })

                }
            </aside>
        </div>
    );

};




